export const Minus = (props) => (
  <svg
    style={{ ...props?.style }}
    width='16'
    height='16'
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M1 7C0.447715 7 0 7.44772 0 8C0 8.55229 0.447715 9 1 9C12.3552 9 3.6448 9 15 9C15.5523 9 16 8.55229 16 8C16 7.44772 15.5523 7 15 7C3.6448 7 12.3552 7 1 7Z'
      fill='inherit'
    />
  </svg>
);
